import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, Card, CardBody, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import CalculationHeader from './CalculationsHeader';
import Accumulation from './Accumulations';
import Adjustment from './Adjustment';
import Purchase from './Purchase';
import Pending from './Pending';
import useAxios from 'hooks/useAxios';



const AccumulationDetails = ({ tenantID, rowData }) => {
      console.log(rowData,"accumulations")
    
   const API = useAxios();
    const [activeButton, setActiveButton] = useState("340B");
    const [dat, setdta] = useState([]);
    const [state, updateState] = useState({
        activeType: 'Accumulation'
    });
    const [AccountTypeID, setAccountTypeId] = useState("1001")
     //const [balance,setBalance]= useState({});
    const [rSelected, setRSelected] = useState(1);
      const [chargecode,setChargeCode] =  useState([]);
    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

    const onUpdateType = (type) => {
        setState({
            activeType: type
        });
    };

    const { activeType } = state;


    
    const recall =(data)=>{ 
       setdta(data);
    }
    const handleExport = async () => {
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        onExport(action, initialFilters);
    };
  
    const handleButtonClick = (button) => {
        setActiveButton(button);
    };
    const handelChange = (num) => {
        setAccountTypeId(num)
    };
const rechargecodelist =(data)=>{
    setChargeCode(data) 
}
    
    return (

        <div>
            <div>
                <Card>
                    <CardBody className='section-devider-border'>
                        <Row>
                            <Col md={3} lg={3} sm={6} xs={6}  >
                                <Col xs="auto">
                                    <ButtonGroup className="buttongrpact" style={{border:"none"}} >
                                        <Button className='buttongrp' color={rSelected === 1 ? "primary" : "#702c62"}
                                         outline onClick={() => { setRSelected(1), handelChange("1001")}} active={rSelected === 1}>
                                            340B
                                        </Button>
                                        <Button className='buttongrp'color={rSelected === 2 ? "primary" : "#702c62"} 
                                        outline onClick={() => { setRSelected(2), handelChange("1002") }} active={rSelected === 2} >
                                             GPO
                                        </Button>
                                        <Button className='buttongrp'color={rSelected === 3 ? "primary" : "#702c62"}
                                         outline onClick={() => { setRSelected(3), handelChange("1003") }} active={rSelected === 3} >
                                             WAC
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Col>
                            <Col md="2" className='flex-wrap mt-2'>
                                <p className="m-0 f-14 mt-1">NDC :</p>
                                <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.ndc}</p>
                            </Col>

                            <Col md="3" className='flex-wrap mt-2'>
                                <p className="m-0 f-14 mt-1">Drug Name : </p>
                                <p className="m-0 f-14 font-weight-500 mt-1">{rowData?.drugName}</p>
                            </Col>
                            <Col md="4" className='flex-wrap mt-2'>
                                <p className="m-0 f-14 mt-1">Current Mapped Charge Code : </p>
                                <p className="m-0 f-14 font-weight-500 mt-1">{chargecode.join(',')}</p>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardBody className="border-top ">
                        <CalculationHeader  activeType={activeType}rechargecodelist={rechargecodelist} data={dat} tenantID={tenantID.tenantID} orgId ={tenantID} AccountTypeID={AccountTypeID} onUpdateType={onUpdateType} rowData={rowData}/>
                        <div className='mt-4'>
                        {activeType === 'Accumulation' && <Accumulation tenantID={tenantID.tenantID} orgId ={tenantID}  recall={recall} rowData={rowData} AccountTypeID={AccountTypeID} />}
                        {activeType === 'Purchase' && <Purchase AccountTypeID={AccountTypeID} orgId ={tenantID} recall={recall} tenantID={tenantID.tenantID} rowData={rowData} />}
                        {activeType === 'Pending' && <Pending tenantID={tenantID.tenantID} orgId ={tenantID} recall={recall} rowData={rowData} AccountTypeID={AccountTypeID} />}
                        {activeType === 'Adjustment' && <Adjustment tenantID={tenantID.tenantID} recall={recall} orgId ={tenantID} rowData={rowData} AccountTypeID={AccountTypeID} />}
                        </div>
                    </CardBody>
                </Card>

            </div>
        </div>
    )
}

export default AccumulationDetails
